/**
 * Created by kisnows on 2016/9/19.
 */
import Icon from './Icon'

export default Icon
